import { render, staticRenderFns } from "./Install.vue?vue&type=template&id=36c0469c"
import script from "./Install.vue?vue&type=script&lang=ts"
export * from "./Install.vue?vue&type=script&lang=ts"
import style0 from "./Install.vue?vue&type=style&index=0&id=36c0469c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports